import { useAppDispatch } from "./useAppDispatch";
import { useCartList } from "./useCartList";
import { useCartProductList } from "./useCartProductList";
import { useLazyGetAllCartWithIdQuery } from "Services";
import { addToProductCart } from "State/actions";
import { useEffect } from "react";

export const useCartProductLoader = () => {
  const dispatch = useAppDispatch();
  const cartList = useCartList();
  const cartProductList = useCartProductList();
  const [getCartItems, { isLoading: cartLoading }] = useLazyGetAllCartWithIdQuery();

  useEffect(() => {
    if (cartList.length === 0) return;
    getCartItems({ cartItems: cartList.map((item) => item.productId) })
      .unwrap()
      .then((response) => {
        if (response) dispatch(addToProductCart(response));
      })
      .catch(() => {});
  }, [cartList]);

  return { cartLoading, cartProductList };
};
